module.exports = __webpack_public_path__ + "img/nezavadna.9dc8e8d6.svg";